import { ScoreTiers } from './scoreTiers';

/**
 * @param {{mover_tier: string}} values
 * @returns {[min: number, max: number]}
 */
export function getTierRange(values) {
	const ranges = {
		[ScoreTiers.All]: [0, 100],
		[ScoreTiers.Listed]: [100, 100],
		[ScoreTiers.High]: [70, 99],
		[ScoreTiers.Medium]: [50, 69],
		[ScoreTiers.Low]: [0, 49],
	};

	const moverTier = values.mover_tier;
	const [min, max] = ranges[moverTier] || ranges['default'];
	return [min, max];
}

/**
 * @param {Number} score
 * @returns {string}
 */
export function getTierFromScore(score) {
	if (score === 100) {
		return ScoreTiers.Listed;
	}
	if (score >= 70) {
		return ScoreTiers.High;
	}
	if (score >= 50) {
		return ScoreTiers.Medium;
	}
	return ScoreTiers.Low;
}
